import { type BalanceSheetId, type Dtos, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey } from "../../financials";

export function useAdminMarkBalanceSheetUnreviewed(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (balanceSheetId: BalanceSheetId) =>
			post<Dtos.Admin.BalanceSheet.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets/${balanceSheetId}/unreview`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
		},
	});

	return {
		unreviewBalanceSheet: mutation.mutate,
		unreviewBSLoading: mutation.isPending,
		unreviewBSError: mutation.error,
		resetUnreviewBSError: mutation.reset,
	};
}
